import { ConsultantContainer } from "../containers/ConsultantContainer";

export const ConsultantPage = () => (
    <ConsultantContainer/>
)